import type { StepContentConfig } from '../../utils';

export const attentePaiementStepContent: StepContentConfig = {
    mainTitle: {
        site: 'Suivi du paiement',
        conseiller: 'Suivi paiement client',
        conseillermae: 'Suivi paiement adhérent',
    },
    lienPaiementEnvoye: {
        conseiller:
            'Un lien de paiement a été envoyé sur la boîte email de votre client. Le paiement est obligatoire pour valider la souscription du contrat.',
        conseillermae:
            'Un lien de paiement a été envoyé sur la boîte email de votre adhérent. Le paiement est obligatoire pour valider la souscription du contrat.',
    },
    paiementEffectue: {
        site: 'Le paiement a été effectué',
        conseiller: 'Le paiement client a été effectué',
        conseillermae: 'Le paiement adhérent a été effectué',
    },
    paiementEnAttente: {
        site: 'Paiement en attente',
        conseiller: 'Paiement client en attente',
        conseillermae: 'Paiement adhérent en attente',
    },
    buttonUpdate: {
        site: 'Mettre à jour',
    },
    lastUpdate: {
        site: 'Dernière mise à jour :',
    },
};
